<div class="page-container reserve-confirm-content">
  <!--title 標題-->
  <div class="page-title-block">
    <h2 class="page-title">{{ 'reserve-confirm.title' | translate }}</h2>
    <div class="page-subtitle-block">
      <img
        width="26"
        height="26"
        ngSrc="assets/img/i-clock-user.svg"
        alt="clock-user"
      />
      <p [innerHTML]="'reserve-confirm.hint' | translate"></p>
    </div>
  </div>

  <!--小計-->
  <div class="card-content register-card-content">
    <h3 class="register-card-title">
      {{ 'reserve-confirm.total' | translate }}
    </h3>
    <div class="confirm-subtotal">
      <div class="confirm-subtotal-item">
        <p>{{ selectedPackage }}</p>
        <p><label>$</label>{{ packageExamPrice | numberComma }}</p>
      </div>
      <div class="confirm-subtotal-item">
        <p>{{ 'reserve-confirm.add-exam-item' | translate }}</p>
        <p><label>$</label>{{ addExamInfoPrice | numberComma }}</p>
      </div>

      <!--企業補助金額-->
      <!-- 2026.5.20 Jon、PM亮豪決定預約過程中有補助金額就顯示（方案頁/確認方案及檢查項目）。-->
       @if (
        sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.ENTERPRISE && businessSubsidyAmount > 0
      ) {
        <div class="confirm-subtotal-item">
          <p>{{ 'reserve-confirm.subsidy-amount' | translate }}</p>
          <p class="remove-item">
            <label>-$</label>{{ businessSubsidyAmount | numberComma }}
          </p>
        </div>
      }

      @if (invalidExamItemQuestionMap) {
        <div class="confirm-subtotal-item">
          <p>{{ 'reserve-confirm.remove-exam-item' | translate }}</p>
          <p class="remove-item">
            <label>-$</label>{{ removeExamInfoPrice | numberComma }}
          </p>
        </div>

        <!-- @for (entry of invalidExamItemQuestionMap; track entry[0]) {
          <div class="confirm-subtotal-item">
            <div class="confirm-remove-item">
              <img
                width="14"
                height="14"
                ngSrc="assets/img/i-shield-warning.svg"
                alt=""
              />
              <p>
                {{
                  'reserve-confirm.remove-message'
                    | translate
                      : {
                          questionName: entry[1][0].questionName || '',
                          examName: getExamName(entry[0]),
                          price: getExamInfoPrice(entry[0]),
                        }
                }}
              </p>
            </div>
          </div>
        } -->

        <!-- @for (entry of removeItemQuestionMap; track entry.examItem) {
          <div class="confirm-subtotal-item">
            <div class="confirm-remove-item">
              <img
                width="14"
                height="14"
                ngSrc="assets/img/i-shield-warning.svg"
                alt=""
              />
              <p>
                {{
                  'reserve-confirm.remove-message'
                    | translate
                      : {
                          questionName: '',
                          examName: entry.examName,
                          price: entry.examPrice | numberComma,
                        }
                }}
              </p>
            </div>
          </div>
        } -->
      }

      @for (entry of invalidExamItemQuestionMap; track entry[0]) {
        <div class="confirm-subtotal-item">
          <div class="confirm-remove-item">
            <img
              width="14"
              height="14"
              ngSrc="assets/img/i-shield-warning.svg"
              alt=""
            />
            <p>
              {{
                'reserve-confirm.remove-message'
                  | translate
                    : {
                        questionName: entry[1][0].questionName || '',
                        examName: getExamName(entry[0]),
                      }
              }}
            </p>
          </div>
        </div>
      }

      <!-- 被刪除三寶 -->
      <!-- @for (item of threeBaoItemList; track item.examItem) {
        <div class="confirm-subtotal-item">
          <div class="confirm-remove-item">
            <img
              width="14"
              height="14"
              ngSrc="assets/img/i-shield-warning.svg"
              alt=""
            />
            <p>
              {{ 'reserve-confirm.remove-message' | translate: { examName: item.examName } }}
            </p>
          </div>
        </div>
      } -->

      <div class="confirm-total-payment">
        <p>{{ 'reserve-confirm.payment-amount' | translate }}</p>
        <p class="confirm-total-price">
          <label>$</label>
          @if (paymentAmount < 0 && sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.ENTERPRISE) {
            0
          } @else {
            {{ paymentAmount | numberComma }}
          }
        </p>
      </div>
    </div>
  </div>

  <!--方案檢項-->
  <div class="card-content register-card-content">
    <h3 class="register-card-title">
      {{ selectedPackage }}
    </h3>
    @if (sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.PERSONAL) {
      @for (examTypeMap of examInfoListByType.entries(); track examTypeMap[0]) {
        <div class="reserve-confirm-cart-item">
          @if(examTypeMap[0] !== 'unknown'){
                <h3>{{ examTypeMap[0] }}</h3>
              }
          @for (deptMap of examTypeMap[1]; track deptMap[0]) {
            <div
              class="reserve-confirm-cart-item-title"
              (click)="
                toggleDeptOpenStateByExamType(examTypeMap[0], deptMap[0])
              "
            >
              <h4>{{ deptMap[0] }}</h4>
              <div>
                @if (shouldShowWarning(deptMap[1])) {
                  <img
                    width="20"
                    height="20"
                    ngSrc="assets/img/i-shield-warning.svg"
                    alt=""
                  />
                }
                <button mat-button class="btn-icon">
                  <img
                    width="24"
                    height="24"
                    alt=""
                    [ngSrc]="
                      getDeptOpenStateByExamType(examTypeMap[0], deptMap[0])
                        ? 'assets/img/i-arrow-up.svg'
                        : 'assets/img/i-arrow-down.svg'
                    "
                  />
                </button>
              </div>
            </div>
            @if (getDeptOpenStateByExamType(examTypeMap[0], deptMap[0])) {
              <div class="reserve-confirm-cart-item-block">
                @for (examInfo of deptMap[1]; track examInfo.examItem) {
                  <!-- 檢項已刪除-->
                  @if (invalidExamItemQuestionMap?.has(examInfo.examItem)) {
                    <div class="reserve-confirm-cart-checked-item remove-item">
                      <div>
                        <button
                          mat-icon-button
                          type="button"
                          class="btn-icon btn-info"
                          (click)="showExamDialog(examInfo)"
                        >
                          <img
                            width="14"
                            height="14"
                            ngSrc="assets/img/i-info.svg"
                            alt=""
                          />
                        </button>
                        <p>{{ examInfo.examName }}</p>
                      </div>
                      <p class="remove-msg">
                        {{
                          'reserve-confirm.exam-item-has-been-removed'
                            | translate
                        }}
                      </p>
                    </div>
                  }
                  <!-- 三寶檢項 -->
                  @else if (isThreeBaoItem(examInfo.examItem)) {
                    <div class="reserve-confirm-cart-checked-item remove-item">
                      <div>
                        <button
                          mat-icon-button
                          type="button"
                          class="btn-icon btn-info"
                          (click)="showExamDialog(examInfo)"
                        >
                          <img
                            width="14"
                            height="14"
                            ngSrc="assets/img/i-info.svg"
                            alt=""
                          />
                        </button>
                        <p>{{ examInfo.examName }}</p>
                      </div>
                      <p class="remove-msg">
                        {{
                          'reserve-confirm.three-bao-item-has-been-removed'
                            | translate
                        }}
                      </p>
                    </div>
                  }
                  <!-- @else if (isItemRemoved(examInfo.examItem)) {
                    <div class="reserve-confirm-cart-checked-item remove-item">
                    <div>
                      <button
                        mat-icon-button
                        type="button"
                        class="btn-icon btn-info"
                        (click)="showExamDialog(examInfo)"
                      >
                        <img
                          width="14"
                          height="14"
                          ngSrc="assets/img/i-info.svg"
                          alt=""
                        />
                      </button>
                      <p>{{ examInfo.examName }}</p>
                    </div>
                    <p class="remove-msg">
                      {{
                        'reserve-confirm.exam-item-has-been-removed'
                          | translate
                      }}
                    </p>
                  </div>
                  } -->
                  @else {
                    <div class="reserve-confirm-cart-checked-item">
                      <div>
                        <button
                          mat-icon-button
                          type="button"
                          class="btn-icon btn-info"
                          (click)="showExamDialog(examInfo)"
                        >
                          <img
                            width="14"
                            height="14"
                            ngSrc="assets/img/i-info.svg"
                            alt=""
                          />
                        </button>
                        <p>{{ examInfo.examName }}</p>
                      </div>
                    </div>
                  }
                }
              </div>
            }
          }
        </div>
      }
    } @else {
      <!--企業方案-->
      @for (examTypeMap of examInfoListByType.entries(); track examTypeMap[0]) {
        <div class="reserve-confirm-cart-item">
          @if(examTypeMap[0] !== 'unknown'){
            <h3>{{ examTypeMap[0] }}</h3>
          }
          @for (deptMap of examTypeMap[1]; track deptMap[0]) {
            <div
              class="reserve-confirm-cart-item-title"
              (click)="
                toggleDeptOpenStateByExamType(examTypeMap[0], deptMap[0])
              "
            >
              <h4>{{ deptMap[0] }}</h4>
              <div>
                @if (shouldShowWarning(deptMap[1])) {
                  <img
                    width="20"
                    height="20"
                    ngSrc="assets/img/i-shield-warning.svg"
                    alt=""
                  />
                }
                <button mat-button class="btn-icon">
                  <img
                    width="24"
                    height="24"
                    alt=""
                    [ngSrc]="
                      getDeptOpenStateByExamType(examTypeMap[0], deptMap[0])
                        ? 'assets/img/i-arrow-up.svg'
                        : 'assets/img/i-arrow-down.svg'
                    "
                  />
                </button>
              </div>
            </div>
            @if (getDeptOpenStateByExamType(examTypeMap[0], deptMap[0])) {
              <div class="reserve-confirm-cart-item-block">
                @for (examInfo of deptMap[1]; track examInfo.examItem) {
                  <!-- 檢項已刪除-->
                  @if (invalidExamItemQuestionMap?.has(examInfo.examItem)) {
                    <div class="reserve-confirm-cart-checked-item remove-item">
                      <div>
                        <button
                          mat-icon-button
                          type="button"
                          class="btn-icon btn-info"
                          (click)="showExamDialog(examInfo)"
                        >
                          <img
                            width="14"
                            height="14"
                            ngSrc="assets/img/i-info.svg"
                            alt=""
                          />
                        </button>
                        <p>{{ examInfo.examName }}</p>
                      </div>
                      <p class="remove-msg">
                        {{
                          'reserve-confirm.exam-item-has-been-removed' | translate
                        }}
                      </p>
                    </div>
                  } @else {
                    <div class="reserve-confirm-cart-checked-item">
                      <div>
                        <button
                          mat-icon-button
                          type="button"
                          class="btn-icon btn-info"
                          (click)="showExamDialog(examInfo)"
                        >
                          <img
                            width="14"
                            height="14"
                            ngSrc="assets/img/i-info.svg"
                            alt=""
                          />
                        </button>
                        <p>{{ examInfo.examName }}</p>
                      </div>
                    </div>
                  }
                }
              </div>
            }
          }
        </div>
      }
    }
  </div>

  <!--加購檢項-->
  @if (hasValidAddExamItems) {
    <div class="card-content register-card-content">
      <h3 class="register-card-title">
        {{ 'reserve-add.add-exam-item' | translate }}
      </h3>
      <div class="reserve-confirm-cart-item add-item">
        @for (addExamInfo of addExamInfoList; track addExamInfo.examItem) {
          @if (!invalidExamItemQuestionMap?.has(addExamInfo.examItem)) {
            <div class="reserve-confirm-cart-checked-item">
              <div>
                <button
                  mat-icon-button
                  type="button"
                  class="btn-icon btn-info"
                  (click)="showExamDialog(addExamInfo)"
                >
                  <img
                    width="14"
                    height="14"
                    ngSrc="assets/img/i-info.svg"
                    alt=""
                  />
                </button>
                <p>{{ addExamInfo.examName }}</p>
              </div>
              <div>
                <p class="reserve-confirm-add-cart-item">
                  <label>${{ (addExamInfo.discountedPrice ?? addExamInfo.price?.toString()) | numberComma }}</label> 
                </p>
              </div>
            </div>
          }
        }
      </div>
    </div>
  }

  <!--頁面：固定按鈕區塊-->
  <div class="page-btn-block">
    <div class="btn-group">
      @if (
        !invalidExamItemQuestionMap || invalidExamItemQuestionMap.size == 0
      ) {
        <button
          mat-button
          (click)="adjustItem()"
          class="btn-outline-primary btn-size-l"
        >
          {{ 'reserve-confirm.adjust' | translate }}
        </button>
      }
      <button
        mat-button
        (click)="confirm()"
        class="btn-fill-primary btn-size-l"
      >
        {{ 'reserve-confirm.confirm' | translate }}
      </button>
    </div>
    <div class="page-pay">
      <!-- 企業預約且金額小於0時顯示補助尚餘 -->
       @if (paymentAmount < 0 && sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.ENTERPRISE) {
        <span>{{ 'reserve-add.subsidy-amount' | translate }}</span>
      } @else {
        <span>{{ 'reserve-confirm.payment-amount' | translate }}</span>
      }
      <label>$</label>
      @if (paymentAmount < 0 && sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.ENTERPRISE) {
        {{ Math.abs(paymentAmount) | numberComma }}
      } @else {
        {{ Math.abs(paymentAmount) | numberComma }}
      }
    </div>
  </div>
</div>
